var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AuthRepository } from '../../infrastructure/repositories/auth.repository.impl';
import { SageRepository } from '../../infrastructure/repositories/sage.repository.impl';
export class SageService {
    constructor() {
        this.repository = new SageRepository();
        this.authRepository = new AuthRepository();
    }
    loginFromSageAsync(encryptedId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!encryptedId)
                    throw new Error('Missing ID');
                const { accessToken, expiration, refreshToken } = yield this.repository.getSageDecryptAsync(encryptedId);
                if (!accessToken)
                    throw new Error('No access token returned');
                return {
                    accessToken,
                    expiration,
                    refreshToken,
                };
            }
            catch (e) {
                console.error('Error in Sage login', e);
                return null;
            }
        });
    }
}
